module.exports = __webpack_public_path__ + "img/btn-marquee-disable.654e4201.svg";